import { type FC, memo } from 'react';
import type { SidebarProps } from '../../types';
import CreateButton from '../sidebar/CreateButton';
import MeetingList from '../sidebar/MeetingList';

const Sidebar: FC<SidebarProps> = ({
  meetings,
  selectedRoom,
  onSelect,
  onCreate,
  isCreating,
  canCreate,
  creationDisabledReason,
  isFreePlan,
  baseJoinUrl,
  defaultMeetingId,
}) => (
  <div className="personal-meetings-modal__sidebar">
    <div className="personal-meetings-modal__sidebar-actions">
      <CreateButton
        onClick={onCreate}
        isCreating={isCreating}
        canCreate={canCreate}
        disabledReason={creationDisabledReason}
      />
    </div>

    <div className="personal-meetings-modal__meeting-list">
      <MeetingList
        meetings={meetings}
        selectedRoom={selectedRoom}
        onSelect={onSelect}
        canCreate={canCreate}
        disabledReason={creationDisabledReason}
        isFreePlan={isFreePlan}
        baseJoinUrl={baseJoinUrl}
        defaultMeetingId={defaultMeetingId}
      />
    </div>
  </div>
);

export default memo(Sidebar);
